// @ts-nocheck
import * as api from '@/api/index';
import { DetailStore, PayDialogStore, PersonInfoStore, RecordStore, ResultStore } from '@/store/index';
import { url, util, CustomException } from '@tencent/ppd-base-libs';

import jsapi from '@/fit-components/jsapi';
import { fen2yuan, yuan2fen } from '@/business/helper';
import { showDialog } from '@tencent/wphk-components-dialog';
import { showLoading, hideLoading } from '@tencent/wphk-components-loading';
import { getFormatedCharityCfg } from '@/api/cfg';
import { initCfgStore, setCfgStore, getOrganByOid, setDonatedProjectCache, getProjectByIdInAll } from '@/business/cfg';

const code = url.getUrlParam('code');

function filterMobile(rawVal) {
  let val = rawVal;
  // 去掉空格
  val = val.replace(/ /g, '');
  // 去掉非数字
  val = val.replace(/[^0-9]/g, '');
  if (val.length > 11) {
    // 只允许11位
    val = val.substr(0, 11);
  }
  return val;
}

function filterName(rawVal) {
  let val = rawVal;

  // 1、多个空格变为一个空格
  val = val.replace(/ +/g, ' ');
  // val = val.replace(/\|+/g, '');
  val = val.replace(/[^a-zA-Z \u4e00-\u9fa5]/g, '');

  // 2、只允许输入a-zA-Z字符
  // val = val.replace(/[^a-zA-Z ]/g, '');
  val = val.substr(0, 20);

  return val;
}

function filterEmail(rawVal) {
  let val = rawVal;
  // 去掉空格
  val = val.replace(/ /g, '');
  // 去掉不允许的字符
  val = val.replace(/[^a-zA-Z0-9\-._@]/g, '');
  val = val.substr(0, 34);
  return val;
}

function checkAmount() {
  const limit = 1000000;
  if (parseFloat(yuan2fen(PayDialogStore.inputAmount), 10) > limit) {
    showDialog({
      content: '對不起，每次的捐款金額最高為港幣10000元正。',
    });
    PayDialogStore.inputAmount = '10000';
  }
}

function handleInputVal(srcRawVal, inputName) {
  let rawVal = srcRawVal;
  switch (inputName) {
    case 'phone':
      rawVal = filterMobile(rawVal);
      PersonInfoStore.donor_phone = rawVal;
      break;
    case 'name':
      rawVal = filterName(rawVal);
      PersonInfoStore.donor_name = rawVal;
      break;
    case 'email':
      rawVal = filterEmail(rawVal);
      PersonInfoStore.donor_email = rawVal;
      break;
    default:
      break;
  }
  return rawVal;
}

function goAuth(scope: string) {
  let locationUrl = location.href;
  locationUrl = locationUrl.replace(/code=[^&]*/, '');
  locationUrl = locationUrl.replace(/#.*/, '');
  location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf016e24ccf50c07a&redirect_uri=${encodeURIComponent(locationUrl)}&response_type=code&scope=${scope}&state=charity#wechat_redirect`;
}

function handleResError(res, scope = 'snsapi_base') {
  if (res.retcode === '1610620012' || res.retcode === '1610620013') {
    goAuth(scope);
  } else if (res.retcode !== '0' && scope === 'snsapi_base') {
    showDialog({
      content: res.retmsg,
    });
  }
}

function wxPayCallback() {
  const params = {
    t: (new Date()).getTime(),
    listid: url.getUrlParam('listid'),
    spid: url.getUrlParam('spid'),
  };
  if (code) {
    params.code = code;
  }
  api.wxPayCallback(params).then(() => {

  })
    .catch(() => {

    });
}

async function getHomepageInit() {
  const params = {
    t: (new Date()).getTime(),
  };
  if (code) {
    params.code = code;
  }
  const cfgPromise = getFormatedCharityCfg();
  const initPromise = api.getHomepageInit(params);
  const [err, result] = await util.to(Promise.all([cfgPromise, initPromise]));
  if (err) {
    handleResError(err);
    throw new CustomException(err, 'getHomepageInitException', 'getHomepageInitException in charity.ts');
  }
  const [pageCfg, pageData] = result;

  // 初始化页面配置
  setCfgStore(pageCfg);

  return {
    pageData,
  };
}

function handleIllegalData(srcData) {
  const data = srcData;
  Object.keys(data).forEach((key) => {
    if (data[key] === 'N/A') {
      data[key] = '';
    }
  });

  if (data.donor_name) {
    data.donor_name = data.donor_name.replace(/(ping)\./i, '$1 ');
  }
  return data;
}

function getDonorQry(cb) {
  const params = {
    t: (new Date()).getTime(),
  };
  if (code) {
    params.code = code;
  }
  api.getDonorQry(params).then((srcRes) => {
    let res = srcRes;
    if (res.donor_name && res.donor_email) {
      res = handleIllegalData(res);
      PersonInfoStore.donor_name = res.donor_name;
      PersonInfoStore.donor_email = res.donor_email;
      PersonInfoStore.donor_phone = res.donor_phone;
    }

    if (cb) {
      cb();
    }
  })
    .catch((res) => {
      handleResError(res);
    });
}

let getJssdkSignLoading = false;
function getJssdkSign(cb) {
  if (getJssdkSignLoading) {
    return;
  }
  // let redirectUrl = encodeURIComponent(location.href.split('#')[0]);
  const [redirectUrl] = location.href.split('#');
  const params = {
    t: (new Date()).getTime(),
    url: redirectUrl,
  };
  if (code) {
    params.code = code;
  }
  getJssdkSignLoading = true;
  api.getJssdkSign(params).then((res) => {
    getJssdkSignLoading = false;
    const conf = {
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.appId, // 必填，公众号的唯一标识
      timestamp: res.timeStamp, // 必填，生成签名的时间戳
      nonceStr: res.nonceStr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名
      jsApiList: [
        'getH5PrepayRequest',
      ],
    };

    jsapi.init(conf);
    if (cb) {
      cb();
    }
  })
    .catch((res) => {
      getJssdkSignLoading = false;
      handleResError(res);
    });
}

let orderReqLoading = false;
function orderReq(skip) {
  if (orderReqLoading) {
    return;
  }
  orderReqLoading = true;
  showLoading({
    title : '加載中', //写死繁体
  });
  const params = {
    t: (new Date()).getTime(),
  };
  if (code) {
    params.code = code;
  }
  params.product_id = DetailStore.pid;
  params.organization_id = DetailStore.oid;
  if (PayDialogStore.isUsePreset) {
    params.amount = yuan2fen(PayDialogStore.selectedAmount);
  } else {
    params.amount = yuan2fen(PayDialogStore.inputAmount);
  }
  if (skip) {
    params.need_receipt = '0';
    params.donor_name = 'N/A';
    params.donor_phone = 'N/A';
    params.donor_email = 'N/A';
    params.receive_notify = '0';
  } else {
    params.need_receipt = PayDialogStore.need_receipt;
    params.donor_name = PersonInfoStore.donor_name.trim();
    params.donor_name = params.donor_name.replace(/(ping) /i, '$1.');
    params.donor_phone = PersonInfoStore.donor_phone;
    params.donor_email = PersonInfoStore.donor_email;
    params.receive_notify = PersonInfoStore.receive_notify;
  }
  params.entrance = '1';

  getJssdkSign(() => {
    api.orderReq(params).then((res) => {
      orderReqLoading = false;
      const conf = {
        appId: res.appId,
        timeStamp: res.timeStamp,
        nonceStr: res.nonceStr,
        package: res.package,
        signType: 'SHA1',
        paySign: res.paySign,
      };
      jsapi.getH5PrepayRequest(conf);
      hideLoading();
    })
      .catch((res) => {
        orderReqLoading = false;
        handleResError(res);
        hideLoading();
      });
  });
}

function hisQry() {
  if (RecordStore.showMoreLoading) {
    return;
  }
  if (RecordStore.has_next_page === 0) {
    return;
  }
  const params = {
    t: (new Date()).getTime(),
  };
  if (code) {
    params.code = code;
  }
  RecordStore.showMoreLoading = true;
  params.page_no = RecordStore.page_no;
  api.hisQry(params).then((res) => {
    RecordStore.has_next_page = res.has_next_page;
    if (!res.his_list) {
      if (RecordStore.page_no === 0) {
        RecordStore.noData = true;
      }
    } else {
      RecordStore.noData = false;
      res.his_list.forEach((srcItem) => {
        const item = srcItem;
        const projectInCfg = getProjectByIdInAll(item.product_id);
        if (!projectInCfg) {
          new CustomException(null, 'projectNotFound', `找不到项目${item.product_id}的配置`);
          return;
        }
        const organCfg = getOrganByOid(projectInCfg.oid);
        item.logo = organCfg.oicon || '';
        item.img = projectInCfg.img || '';
        item.title = projectInCfg.title || '';
        item.amount = `HK$ ${fen2yuan(item.amount)}`;
        item.state = item.state === '2' ? '付款成功' : '待支付';
        RecordStore.his_list.push(item);
      });
    }
    RecordStore.page_no += 1;
    RecordStore.showMoreLoading = false;
    if (RecordStore.his_list.length < 8) {
      hisQry();
    }
  })
    .catch((res) => {
      handleResError(res);
      RecordStore.showMoreLoading = false;
    });
}

async function getUserInfo() {
  const scope = 'snsapi_userinfo';

  const code = url.getUrlParam('code') || '';
  const [err, res] = await util.to(api.qryUserInfo(code));
  if (err) {
    handleResError(err, scope);
    throw new CustomException(err, 'getUserInfoErr', '慈善结果页获取用户信息接口报错');
  }

  if (+res.auth === 0) {
    goAuth(scope);
  }

  return res;
}


async function handlePayCallback() {
  ResultStore.product_id = url.getUrlParam('pid');
  ResultStore.organization_id = url.getUrlParam('oid');
  ResultStore.donor_name = url.getUrlParam('name');
  ResultStore.donor_email = url.getUrlParam('email');
  ResultStore.donor_phone = url.getUrlParam('phone');
  ResultStore.amount = fen2yuan(url.getUrlParam('amount'));
  ResultStore.listid = url.getUrlParam('listid');

  await initCfgStore();

  const projectInCfg = getProjectByIdInAll(ResultStore.product_id);
  const organCfg = getOrganByOid(projectInCfg.oid);

  ResultStore.logo = organCfg.oicon || '';
  ResultStore.oname = organCfg.oname || '';
  ResultStore.title = projectInCfg.title || '';
  ResultStore.isNineProj = projectInCfg.isNineProj || false;
  ResultStore.state = '付款成功';
  handleIllegalData(ResultStore);
  wxPayCallback();

  setDonatedProjectCache(ResultStore.product_id);
}

function detailQry(recordItem) {
  const params = {
    t: (new Date()).getTime(),
  };
  if (code) {
    params.code = code;
  }
  params.listid = recordItem.listid;
  params.product_id = recordItem.product_id;
  params.organization_id = recordItem.organization_id;

  return api.detailQry(params).then((srcRes) => {
    let res = srcRes;
    res = handleIllegalData(res);
    ResultStore.donor_name = res.donor_name;
    ResultStore.donor_email = res.donor_email;
    ResultStore.donor_phone = res.donor_phone;
    ResultStore.amount = fen2yuan(res.amount);
    ResultStore.listid = recordItem.listid;

    const projectInCfg = getProjectByIdInAll(recordItem.product_id);
    const organCfg = getOrganByOid(projectInCfg.oid);
    ResultStore.logo = organCfg.oicon || '';
    ResultStore.img = projectInCfg.img || '';
    ResultStore.title = projectInCfg.title || '';
    ResultStore.oname = organCfg.oname || '';

    ResultStore.state = res.state === '2' ? '付款成功' : '待支付';
    ResultStore.transaction_id = res.transaction_id;
    ResultStore.pay_time = res.pay_time;
  })
    .catch((res) => {
      handleResError(res);
    });
}

export default {
  getHomepageInit,
  getDonorQry,
  orderReq,
  hisQry,
  handlePayCallback,
  detailQry,
  handleInputVal,
  checkAmount,
  getUserInfo,
};
